/**
 * getLpPrefix
 * Get liquid pixels prefix based on the brand
 * @param {string}
 * @returns {string}
 *
 *
 * getLpDamUrl
 * Get liquid pixels prefix based on the brand
 * @param {string}
 * @returns {string}
 */
const lpPrefixes = {
    otherStories: 'https://lp.stories.com/app006prod',
    arket: 'https://lp.arket.com/app006prod',
    cos: 'https://lp.cosstores.com/app006prod',
    monki: 'https://lp.monki.com/app006prod',
};
const lpDamUrl = {
    otherStories: `https://www.stories.com`,
    arket: `https://www.arket.com`,
    cos: `https://www.cosstores.com`,
    monki: `https://www.monki.com`,
};
export const getLpPrefix = (brand) => lpPrefixes[brand] || '';
export const getLpDamUrl = (brand) => lpDamUrl[brand] || '';
//# sourceMappingURL=getLpPrefix.js.map